<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\liveCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Khi có khóa học online mới thì sẽ có thông báo xuất hiện trên góc phải của icon [Khóa học online].</p>
                    <p>&nbsp; Nhấn vào icon [Khóa học online] để xem danh sách các khóa học online.</p>
                    <p>&nbsp; Các khóa học online sẽ được hiển thị theo mặc định trạng thái là "Tất cả" và thời gian diễn ra khóa học là ngày hiện tại.</p>
                    <p>② Tuy nhiên, học viên có thể tìm kiếm khóa học theo từ khóa.</p>
                    <p>③ Tìm kiếm khóa học theo trạng thái: Tất cả, Chưa bắt đầu, Đang dạy, Kết thúc.</p>
                    <p>④ Tìm kiếm khóa học theo thời gian diễn ra khóa học: từ ngày ~ đến ngày ~.</p>
                    <p>⑤ Sau đó, nhấn nút tìm kiếm.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon [Khóa học online] ở phía dưới màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_1.png" alt="" /></div>
                <div><p>② Tại đây sẽ xuất hiện những khóa học bạn được tham gia trong ngày đó. Bạn muốn tìm kiếm khóa học nhanh hơn hãy điền đầy đủ thông tin khóa học đó vào khung tìm kiếm [Khóa học], [Trạng thái], [Thời gian diễn ra khóa học] và nhấn  nút tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\live_course_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/searchLiveCourse_manual.vue